/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlanDay_Input } from './PlanDay_Input';
import type { PlanLock } from './PlanLock';
export type OptimizePlanRequest = {
    days: Array<PlanDay_Input>;
    optimize: OptimizePlanRequest.optimize;
    algorithm?: ('v6' | 'v7' | null);
    lock?: (PlanLock | null);
};
export namespace OptimizePlanRequest {
    export enum optimize {
        SIMULATION_ONLY = 'simulation_only',
        OPTIMIZE = 'optimize',
    }
}

